<template>
  <el-table
    :data="tableData"
    style="width:100%; margin-bottom: 20px;"
    border
  >
    <el-table-column
      prop="head_images"
      label="会议头图"
      width="170"
      fixed
    >
      <template slot-scope="scope" >
        <img :src="scope.row.head_images == null ? '未上传' : scope.row.head_images" width="250px">
      </template>
    </el-table-column>
    <el-table-column
      prop="enterprise_name"
      label="主办方"
      width="200"
      fixed
    ></el-table-column>
    <el-table-column
      prop="title"
      label="会议主题"
      width="180"
      fixed
    ></el-table-column>
    <el-table-column
      label="会议类型"
      width="150"
      prop="type"
    >
    </el-table-column>
    <el-table-column
      prop="begin_start_time"
      label="开始时间"
      width="180"
    ></el-table-column>
    <el-table-column
      prop="begin_end_time"
      label="结束时间"
      width="180"
    ></el-table-column>
    <el-table-column
      prop="registrationnum"
      label="报名人数"
      width="150"
    ></el-table-column>
    <!-- 新增 -->
    <el-table-column
      prop="statusmark"
      label="会议状态"
      width="170"
    ></el-table-column>
    <el-table-column
      prop="states"
      label="是否推荐"
      width="120"
    >
      <template slot-scope="scope">
        <el-select v-model="scope.row.states" placeholder="请选择" size="mini" @change="recommend(scope.row)">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import axios from 'axios'
export default {
  props: ['tableData'],
  data () {
    return {
      tableData: [],
      total: '',
      loading: '',
      currentPage: 1,
      activeName: 0,
      options: [
        {value: 0,
          label: '待推荐'
        },
        {value: 1,
          label: '推荐'
        },
        {value: 2,
          label: '不推荐'
        }
      ],
      active: 0
    }
  },
  methods: {
    // 是否推荐
    recommend (scope) {
      let url = this.$config.API.meeting.recommend
      let data = {
        enterprisemeeting_id: scope.id,
        isrecommend: scope.states
      }
      axios.post(url, data
      ).then(res => {
        this.$message.success('修改成功')
        this.fetchData(this.activeName)
      })
    },
    // 获取列表数据
    fetchData (active) {
      let url = this.$config.API.meeting.list
      this.loading = true
      axios.get(url, {
        params: {
          page: this.currentPage,
          type: Number(this.activeName)
        }
      }).then(res => {
        if (this.activeName === '0') {
          this.tableData = res.data.data.list
          this.total = res.data.TOTAL_NUM
          this.loading = false
          console.log('hhh', this.tableData)
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    }
  },
  watch: {
    // 监听表格数据
    tableData: {
      handler (val, oldVal) {
        this.tableData = val
      }
    }
  },
  mounted () {
    this.fetchData(this.activeName)
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// widghtMeeting.vue?7559b9d2